// English UI strings. Work-mode (stealth) variants use the *Work key.
// Full key structure/glossary follows docs/spec/i18n.md (this is the minimal web-shell set).
export default {
  header: {
    workMode: 'Work mode',
    boss: 'Esc',
    bossHint: 'Press to jump to the sheet',
    settings: 'Settings',
    animation: 'Animation',
  },
  nav: {
    reply: 'Reply', replyWork: 'Draft',
    map: 'Org map', mapWork: 'Stakeholder map',
    diary: 'Diary', diaryWork: 'Notes',
    manage: 'People & org', manageWork: 'Contacts',
    cardLink: 'Profile card', pickLabel: 'Who are you replying to?', done: 'Done',
  },
  map: {
    rel: 'My relations', relWork: 'Influence',
    org: 'Org chart',
    friend: 'Close', friendWork: 'Ally',
    tension: 'Tension', tensionWork: 'Issue',
    reportLine: 'Reporting line',
    writePlaceholder: 'What happened at work today?',
    writePlaceholderWork: 'Add a note…',
    writeButton: 'Log',
    writeHint: 'One line with a name is enough. Mention two people to find a relationship.',
  },
  left: {
    people: 'Coworkers · by closeness', peopleWork: 'Contacts',
    meLevel: 'Me · Lv.{lv}',
    meCount: '{n} notes · {left} to next level',
  },
  diary: {
    safe: 'Encrypted and saved on this device only',
    placeholder: 'What happened at work today? Mention a name to auto-tag (⌘/Ctrl+Enter to save)',
    save: 'Save', all: 'All', empty: 'No notes yet', today: 'Today', yesterday: 'Yesterday',
    rec: 'Record', recStop: 'Stop', cap: 'Capture',
    recNote: 'Kept encrypted, never analyzed',
    ocrRun: 'Read with AI', ocrBusy: 'Reading… (first run takes a bit)', ocrTitle: 'What AI read',
    useReply: 'Reply from this →', noMic: "Can't access the mic", ocrFail: "(couldn't read it)",
    tooShort: 'Too short', voiceInsight: 'Voice note +1', voiceSaved: 'Voice {d} saved', holdRec: 'Hold to record',
  },
  manage: {
    tabPeople: 'People', tabOrg: 'Org', tabRel: 'Relations',
    quickLabel: 'Add in one line', quickPlaceholder: 'e.g. Sales, Yoon, manager, under Park', add: 'Add',
    peopleHint: 'Tap a person to edit inline. Changes are encrypted and saved instantly, reflected in the map and list.',
    fName: 'Name', fTitle: 'Title', fTitlePlaceholder: 'e.g. Sales Lead',
    fAliases: 'Names you use in your diary (comma-separated · masked when sent to AI)', fAliasesPlaceholder: 'e.g. Mr. Park, boss',
    fDept: 'Department', fBoss: 'Reports to', fLevel: 'Level', fClose: 'Closeness to me',
    fCompany: 'Company', myCompany: 'My company',
    companiesTitle: 'Client orgs', addCompany: '+ Add client org', newCompanyName: 'New client',
    far: 'Far', near: 'Close', bossNone: 'None', me: 'Me', deptNone: 'No department',
    del: 'Delete', delSure: 'Really delete? Press once more',
    lv1: 'Exec', lv2: 'Lead', lv3: 'Senior', lv4: 'Mid', lv5: 'Junior',
    orgExec: 'No department · Execs', memberN: '{n}', addToDept: '+ Add person (type a name, Enter)', addDept: '+ Add department',
    orgHint: 'Set only departments and levels — the org chart lays itself out.', newDeptName: 'New department',
    relConfirmed: 'Relationships I confirmed', relNone: 'No relationships yet.', relAddTitle: '+ Add relationship',
    relMemoPlaceholder: 'Note (e.g. joined together)', pickTwo: 'Pick two different people', relExists: 'That relationship already exists. Edit it above.',
    typeFriend: 'Close', typeWork: 'Colleague', typeTension: 'Tension',
    saved: 'Saved', nameExists: 'That name already exists',
  },
  compose: {
    chat: 'Chat', mail: 'Email', situation: 'Situation',
    sit_status_late: 'Status update', sit_ask_help: 'Ask', sit_say_no: 'Decline', sit_nudge: 'Follow up', sit_apology: 'Apology', sit_thanks: 'Thanks',
    incoming: 'Message you received', incomingPlaceholder: 'Paste what they sent (optional)',
    draft: 'Your rough reply', draftHint: "rough is fine", draftPlaceholder: 'Say what you want to say, casually',
    go: 'Polish it', thinking: 'Finding the tone',
    outFor: '{kind} tuned for {name}', kindChat: 'reply', kindMail: 'email',
    copy: 'Copy', copied: 'Copied', again: 'Rewrite', good: 'It worked',
    missing: 'Missing info', engineNote: 'Engine · {engine}',
    simpleTitle: 'Simple mode · a few checks',
    simpleNote: "AI is resting, so we checked with rules. Here's what to tweak.",
    empty: 'Write a draft and press Polish.', allGood: 'Your draft already reads fine for them.',
  },
  simple: {
    d_conclusion_late: 'Is the point (when/what) in the first line?',
    d_over_apology: 'Multiple apologies · one is enough',
    d_hedge: 'Hedging phrases (just, maybe, I was wondering)',
    d_no_deadline: 'No deadline or date',
    d_too_long: 'Long for chat · split into shorter messages',
    d_emoji_mismatch: 'Has emoji · consider dropping for a formal recipient',
  },
  newp: {
    found: 'New name found · add them?', add: 'Add', ignore: 'Dismiss',
    added: '{name} added · set their place in the org',
  },
  onb: {
    t0: 'Replies tuned\nto each person', d0: "Everyone at work talks differently. We polish your chat and email replies to fit the recipient.",
    t1: 'Sharper as\nyou record', d1: 'Jot a line about each person and it becomes their profile. Voice and screenshots work too.',
    t2: 'A leak is the end.\nSo, local encryption', d2: 'Everything is encrypted on this device only. Nothing goes to a server, and a forgotten password cannot be recovered.',
    next: 'Next', start: 'Get started', skip: 'Skip',
  },
  account: {
    title: 'Account', signupTitle: 'Sign up', deleteTitle: 'Delete account', back: 'Back',
    localOnly: 'Right now everything is on this device only', whySignup: 'Sign up and you can restore your notes even if you lose or switch phones. All core features work without an account.',
    signupBackup: 'Sign up & back up', keepData: 'Signing up keeps everything you have so far. Your diary is encrypted — even the operator cannot read it.',
    pendingUntil: 'Deletion pending · fully deleted on {d}', cancelDeletion: 'Cancel deletion',
    login: 'Login', plan: 'Plan', contribute: 'Data contribution (optional)', logout: 'Log out', delete: 'Delete account',
    noName: "We don't ask for your name or phone number.", apple: 'Continue with Apple', google: 'Continue with Google', soon: 'soon',
    email: 'Email', sendCode: 'Send login code',
    codeSent: 'Sent a code to {hint}.', code: 'Verification code',
    agreeAll: 'Agree to all', req: 'Required', opt: 'Optional',
    terms: 'Terms of Service', privacy: 'Privacy (collection & use)', privacyNote: 'Login id, email (optional), language · AI processing and servers are overseas (US)',
    age: 'I am 14 or older', contributeAgree: 'Help improve the app (data contribution)', contributeNote: 'Numbers only, no sentences or names · turn off anytime',
    marketing: 'Get product emails', next: 'Next',
    saveKey: 'Save your recovery key', keyWhy: 'Your diary opens only with this key. The operator cannot open it, so if you lose the key it cannot be restored on another device.',
    copy: 'Copy', savedKey: 'I saved it somewhere safe', finishSignup: 'Finish sign-up',
    onDelete: 'When you delete', delSync: 'Your synced data on the server is erased immediately', del7d: 'Your account is fully deleted after 7 days. Log in before then to cancel',
    delContrib: 'A deletion request is also sent for any anonymous contributed data', delBilling: 'Only billing records are kept 5 years (unlinked from the account), as required by law',
    localQ: 'What about the diary on this device?', localQnote: "It's your device's data, independent of the account.", keep: 'Keep it', wipe: 'Erase it too',
    whyLeave: 'Can you tell us why? (optional)', whyLeaveNote: 'Only used to make the app better.',
    reason_rare: "Don't use it much", reason_reply: "Don't like the replies", reason_privacy: 'Privacy concerns', reason_price: 'Too expensive', reason_other_app: 'Using another app', reason_left_job: 'Changed/left my job',
    reasonMore: 'Anything else (optional)', skip: 'Skip',
    lastCheck: 'One last check', lastCheckNote: 'Confirm with your login once more, then delete.', doDelete: 'Delete account',
    needRequired: 'Required consents are needed', needCode: 'Enter the verification code', keyCopied: 'Recovery key copied',
    signedUp: 'Signed up · your notes continue as they are', loggedOut: 'Logged out · this device keeps its notes',
    deletionCancelled: 'Deletion cancelled', deletedWipe: 'Deletion requested · this device was wiped too', deletedKeep: 'Deletion requested · log in within 7 days to cancel',
    backup: 'Backup · Restore', lastBackup: 'Last backup · {d}', noBackup: 'No backup yet', keyPlaceholder: 'Recovery key (12 words, space-separated)',
    backupNow: 'Back up now', restore: 'Restore to this device', backedUp: 'Backed up · encrypted, even the operator cannot open it', restored: 'Restored · {n} notes',
    keyWrong: 'Recovery key is wrong', needKey: 'Recovery key needed (the 12 words from sign-up)',
  },
  crisis: {
    title: "You're not alone",
    msg: "If things feel heavy right now, there are people to talk to. Reach out below.",
    note: 'This app only helps you take notes; it is not professional counseling. In an emergency, call your local emergency number.',
    close: 'Close',
  },
  lock: {
    setupTitle: 'Create a password',
    setupDesc: 'Your notes stay on this device, encrypted with your password. Nothing is sent to a server.',
    unlockTitle: 'Unlock',
    password: 'Password',
    confirm: 'Confirm password',
    warnLabel: 'I understand that if I forget this password, my notes cannot be recovered.',
    create: 'Get started',
    creating: 'Creating…',
    unlock: 'Unlock',
    unlocking: 'Unlocking…',
    errWrong: 'Incorrect password.',
    errMismatch: 'The two passwords do not match.',
    errShort: 'Password must be at least {n} characters.',
    errWarn: 'Please acknowledge the no-recovery notice.',
    forgot: 'Forgot password (erase everything and start over)',
    forgotConfirm: 'Passwords cannot be recovered. Erase all notes on this device and start over? This cannot be undone.',
  },
  settings: {
    settingsTitle: 'Settings', screen: 'Screen', security: 'Security', disguise: 'Disguise', data: 'Data', helpSec: 'Help',
    theme: 'Theme', themeAuto: 'System', themeLight: 'Light', themeDark: 'Dark', language: 'Language',
    autoLock: 'Auto-lock', min1: '1 min', min5: '5 min', min15: '15 min', min30: '30 min', never: 'Never',
    curPw: 'Current password', newPw: 'New password', change: 'Change password', pwChanged: 'Password changed',
    pwWrong: 'Current password is wrong', pwShort: 'At least {n} characters', lockNow: 'Lock now',
    wipe: 'Erase all notes', wipeConfirm: 'Really erase? Press again (cannot be undone)',
    crisisOpen: 'Crisis help', version: 'Version',
    title: 'Hiding settings',
    cover: 'Cover screen',
    animationOpt: 'Animation',
    animAuto: 'Off in work mode only', animOn: 'Always on', animOff: 'Always off',
    startCover: 'Open to the cover screen',
    away: 'When the window loses focus or you step away',
    awayCover: 'Show cover', awayVeil: 'Blur', awayNone: 'Do nothing',
    idle: 'Away after',
    idle30: '30s', idle60: '1 min', idle300: '5 min', idle0: 'Never',
    pin: 'Password',
    help: 'Hide: Esc or throw the mouse to the top-left corner. Reopen: in the sheet type =password + Enter, elsewhere password + Enter',
  },
  covers: {
    sheet: 'Spreadsheet', docs: 'Document', mail: 'Inbox', kanban: 'Kanban board',
    memo: 'Notes', calc: 'Calculator', weather: 'Weather', todo: 'To-do',
    howMemo: 'Long-press the "Notes" title to reveal the password field',
    howCalc: 'Type your password (PIN) and press = · it really calculates too',
    howWeather: 'Long-press the temperature to reveal the password field',
    howTodo: 'Long-press the "To-do" title to reveal the password field',
  },
  toast: {
    saved: 'Saved',
    animOff: 'Animation off',
    animOnStealth: 'Animation on even in work mode · mind onlookers',
    animOn: 'Animation on',
    settingsSaved: 'Saved',
  },
}
